// Christmas Theme JS

function setCookie(cookieName, cookieValue, cookieExpiration) {
    var d = new Date();
    d.setTime(d.getTime() + (cookieExpiration*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

var $collapse = $('.collapse');
$collapse.collapse('hide');

accounting.settings = {
    currency: {
        symbol : "kr",   // default currency symbol is '$'
        format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal : ",",  // decimal point separator
        thousand: ".",  // thousands separator
        precision : 2   // decimal places
    },
    number: {
        precision : 0,  // default precision on numbers is 0
        thousand: ".",
        decimal : ","
    }
};

$.validator.setDefaults({
    highlight: function(element) {
        $(element).closest('.form-group').addClass('has-error');
        $(element).closest('div.checkbox').addClass('has-error');
        $(element).closest('div.radio').addClass('has-error');
    },
    unhighlight: function(element) {
        $(element).closest('.form-group').removeClass('has-error');
        $(element).closest('div.checkbox').removeClass('has-error');
        $(element).closest('div.radio').removeClass('has-error');
    },
    errorElement: 'span',
    errorClass: 'help-block',
    errorPlacement: function(error, element) {
        if(element.parent('.input-group').length) {
            error.insertAfter(element.parent());
        } else {
            error.insertAfter(element);
        }
    }
});

$('#login-form').validate({
    rules: {
        username: {
            required: true,
            minlength: 2
        },
        password: {
            required: true,
            minlength: 2
        }
    }
});

$('html').on('mouseover','.product-thumbnail video', function() { $(this).get(0).play(); });
$('html').on('mouseout','.product-thumbnail video', function() { $(this).get(0).pause(); });

$collapse.on('hide.bs.collapse', function () {
    $(".shortTxt").show();
    $(".changeText").text($(".changeText").attr('data-moreTxt'));
});
$collapse.on('show.bs.collapse', function () {
    $(".shortTxt").hide();
    $(".changeText").text($(".changeText").attr('data-lessTxt'));
});
var $imagePrimaryOld = $('.primary a');
$('.thumbs .fancybox').hover(function() {
    var $this = $(this);
    var $imageHref = $this.attr('href');
    var $imageTitle = $this.attr('title');
    var $imageSrc = $this.attr('data-src');
    $('.primary a').remove();
    $('.primary video').remove();

    if ($imageHref.indexOf('.mp4') !== -1) {
        $('.primary').append('<video muted preload="auto" autoplay loop style="width: 100%;"><source src="' + $imageHref + '"/></video>');
    } else {
        $imagePreview = $imagePrimaryOld;
        
        $imagePreview.attr('href', $imageHref);
        $imagePreview.attr('title', $imageTitle);
        $imagePreview.css({'background-image': 'url("' + $imageSrc + '")'});

        $('.primary').append($imagePreview);

        $imagePrimaryOld = $imagePreview;
    }


    if ($this.attr('href').indexOf('www.youtube.com') !== -1) {
        $('.primary .fa').show();
    } else {
        $('.primary .fa').hide();
    }
});

$(".fancybox").click(function() {
    var $this = $(this);
    if ($this.attr('href').indexOf('www.youtube.com') !== -1) {
        $.fancybox({
            'padding': 0,
            'autoScale': false,
            'transitionIn': 'none',
            'transitionOut': 'none',
            'title': this.title,
            'width': 680,
            'height': 495,
            'href': this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
            'type': 'swf',
            'swf': {
                'wmode': 'transparent',
                'allowfullscreen': 'true'
            }
        });
    } else {
        if ($this.attr('href').indexOf('.mp4') !== -1) {
            $.fancybox({
                'padding': 0,
                'autoScale': false,
                'transitionIn': 'none',
                'transitionOut': 'none',
                'title': this.title,
                'width': 800,
                'height': 800,
                'href': this.href,
                'type': 'iframe'
            });
        } else {
            $.fancybox({
                'openEffect': 'none',
                'closeEffect': 'none',
                'autoDimensions': false,
                'width': 400,
                'height': 300,
                'title': this.title,
                'href': this.href,
                'type': 'image'
            });
        }
    }

    return false;
});

$(document).on('change', '#form-confirm input, #form-confirm select', function() {
    if ($(this).val().length > 0) {
        $('#formSubmitButton').attr('disabled', false);
    }
});

$(document).on('change keyup', 'input[name="postcode"]', function() {
    var post_code = $(this).val();
    if (post_code.length === 4 && $('select[name="country"]').val() === 'DK') {
        $.ajax({
            url: 'https://dawa.aws.dk/postnumre/?nr=' + post_code,
            type: 'GET',
            dataType: 'json',
            success: function(json) {
                if (json.length > 0 && typeof json[0].navn !== 'undefined') {
                    $('input[name="city"]').val(json[0].navn);
                } else {
                    $('input[name="city"]').val('');
                }
            }
        });
    } else {
        $('input[name="city"]').val('');
    }
});

$(document).on('change', ':input[name="shopDeliveryAddress"]', function() {
    if ($(this).val() > 0) {
        $(':input[name="company"]').val($(this).find(':selected').attr('data-delivery-company-name'));
        $(':input[name="address"]').val($(this).find(':selected').attr('data-delivery-address'));
        $(':input[name="postcode"]').val($(this).find(':selected').attr('data-delivery-zip-code'));
        $(':input[name="city"]').val($(this).find(':selected').attr('data-delivery-city'));
        $(':input[name="country"]').val($(this).find(':selected').attr('data-delivery-country-code'));
    } else {
        $(':input[name="company"]').val('');
        $(':input[name="address"]').val('');
        $(':input[name="postcode"]').val('');
        $(':input[name="city"]').val('');
        $(':input[name="country"]').val('');
    }
});

$(document).on('change', ':input[name="address"], :input[name="postcode"], :input[name="city"], :input[name="country"]', function() {
    $(':input[name="shopDeliveryAddress"]').val('');
});

// Variants
$(document).on('change', '.variants', function(event) {
    var ignoredOption = $(this).attr('id');
    var ignoredValue = $(this).val();
    var variantsSelectors = $('.variants');
    var selectedOptions  = {};
    var strings = [];
    var indexes = [];
    variantsSelectors.each(function(i, e) {
        indexes.push('option' + (i+1));
        if ($(e).val()) {
            selectedOptions['option' + (i+1)] = $(e).val();
        }
    });
    $.each(variants, function(index, object) {
        var str = '';
        $.each(indexes, function(index, value) {
            str += value + ':' + object[value] + ',';
        });
        strings.push(str);
    });
    variantsSelectors.each(function(index, element) {
        // "<select>...</select>"
        var currentOption = $(element).attr('id');
        // var currentValue = $(element).val();
        if (currentOption !== ignoredOption || $(element).val() === '') {
            $('option', element).attr('disabled', true);
            $.each($('option', element), function(index, option) {
                var optionOption = currentOption;
                var optionValue = $(option).val();
                if (optionValue === '') {
                    $(option).attr('disabled', false);
                }
                $.each(strings, function(index, value) {
                    // "<option>...</option>"
                    var searchObject = $.extend({}, selectedOptions);
                    searchObject[optionOption] = optionValue;
                    var l = Object.keys(searchObject).length;
                    var f = 0;
                    $.each(searchObject, function(index, option) {
                        var search = index + ':' + option + ',';
                        if (value.indexOf(search) > -1) {
                            f = f +1;
                        }
                    });
                    if (l === f) {
                        $(option).attr('disabled', false);
                    }
                });
            });
        }
    });

    var allSet = true;
    variantsSelectors.each(function(i, e) {
        if (!$(e).val()) {
            allSet = false;
        }
    });

    var selectedObject = false;
    if (allSet === true) {
        $.each(variants, function(index, variantObject) {
            var objectFound = true;
            variantsSelectors.each(function(i, e) {
                if (variantObject[$(e).attr('id')] !== $(e).val()) {
                    objectFound = false;
                }
            });
            if (objectFound === true) {
                selectedObject = variantObject;
            }
        });
    }

    if (typeof selectedObject === 'object') {
        $('.productPrice').html(selectedObject.currentPrice);
        $('.productRetailPrice').html(selectedObject.retailPrice);
        var quantityHtml = '';
        if (selectedObject.quantityManagement === 'steps') {
            var quantitySteps = selectedObject.steps.split(',');
            quantityHtml = '<select class="form-control" required="required" name="quantity">';
            $.each(quantitySteps, function(index, value) {
                quantityHtml += '<option value="'+value+'">'+value+'</option>';
            });
            quantityHtml += '</select>';
        } else {
            quantityHtml = '<input class="form-control" required="required" name="quantity" type="text" value="'+selectedObject.minimum+'">';
        }
        $('.productOrderQuantity').html(quantityHtml);
    }
});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var pageBottom = false;
var productsContainer = $('.product-scroller');
var category = productsContainer.data('category');
var page = 1;
var shopToken = $('meta[name="_token"]').attr('content');
var shopUrl = $('meta[name="_shop"]').attr('content');
var lastPage = false;

var $roundTriggerWrap = $('.round-trigger-wrap');
var $roundTrigger = $('.round-trigger');

var c = parseInt(getParameterByName('c'));
var c2 = parseInt(getCookie('categoryId'));

if ($roundTriggerWrap.length) {
    if (c > 0) {
        category = c;
    } else if (c2 > 0) {
        c = c2;
        category = c;
    } else {
        // Always select first
        c = parseInt($roundTrigger.first().data('category-id'));
        category = c;
    }

    if (c > 0) {
        setCookie('categoryId', category, 31);
        $('[data-category-id="' + category + '"]', $roundTriggerWrap).addClass('active');
        $('.cat').hide();
        $('.cat.cat-' + category).show();
    }
}

$(function() {
    if (productsContainer.length) {
        pageBottom = true;
        loadProducts();
    }
});

function pageBottomLoad() {
    if (productsContainer.length && pageBottom === false) {
        if ($(window).scrollTop() + $(window).height() >= $(document).height() - 300) {
            pageBottom = true;
            loadProducts();
        }
    }
}

function appendProducts(products, promotionQuotes) {
    var itemSetLength = products.length;
    var timeout = 0;
    var interval = timeout;

    var getCurrentPromotionQuotesIds = $('.promotion-quote').map(function () {
        return $(this).data('promotion-quote-id')
    }).get();

    var filterPromotionQuotes = promotionQuotes.filter(function (item) {
        return $.inArray(item.id, getCurrentPromotionQuotesIds) === -1;
    });

    var countProductItems = $('.product-item').length + 1;

    $.each(products, function(index, value) {
        setTimeout(function() {
            if (countProductItems % 7 === 0 && filterPromotionQuotes.length > 0) {
                var item = filterPromotionQuotes.shift();
                productsContainer.append(item.html)
                    .find('.product-item')
                    .last()
                    .fadeIn(timeout * 2);
                countProductItems++;
            }
            countProductItems++;

            productsContainer.append(value)
                .find('.product-item')
                .last()
                .fadeIn(timeout * 2);

            if (index === itemSetLength - 1) {
                $('.product-loader i').hide();
                $('.form-filter button').attr('disabled', false);
                pageBottom = false;
                pageBottomLoad();
            }
        }, interval);
        interval += timeout;
    });
}

function loadProducts() {
    if (pageBottom === true && lastPage === false) {
        $.ajax(
            {
                headers: {'X-CSRF-TOKEN': shopToken},
                type: 'POST',
                url: shopUrl + '/' + FRONTEND_LANGUAGE + '/ajax/load-products',
                dataType: 'json',
                data: {
                    category: category,
                    page: page,
                    filters: {}
                },
                beforeSend: function() {
                    $('.product-loader i').show();
                    $('.form-filter button').attr('disabled', true);
                },
                success: function(json) {
                    var products = json.data;
                    var promotionQuotes = json.promotion_quotes;

                    if (products.length) {
                        appendProducts(products, promotionQuotes);
                    } else {
                        lastPage = true;
                        $('.product-loader i').hide();
                        $('.form-filter button').attr('disabled', false);
                        $('.product-loader span').show();
                    }
                    page += 1;
                },
                complete: function() {

                }
            }
        );
    }
}

$(window).scroll(function() {
    pageBottomLoad();
});

function refreshProducts() {
    if (productsContainer.length) {
        productsContainer.empty();
        page = 1;
        pageBottom = true;
        lastPage = false;
        loadProducts();
        $('.product-loader i').show();
        $('.form-filter button').attr('disabled', true);
        $('.product-loader span').hide();
    }
}

if ($roundTriggerWrap.length) {
    var $initCategory = productsContainer.data('category');
    $roundTrigger.on('click', function() {
        var $this = $(this);
        var $categoryId = $this.data('category-id');
        $('.cat').hide();
        if ($this.hasClass('active')) {
            $roundTrigger.removeClass('active');
            category = $initCategory;
        } else {
            $roundTrigger.removeClass('active');
            $this.addClass('active');
            category = $categoryId;
        }

        $('.cat.cat-' + category).show();
        setCookie('categoryId', category, 31);

        refreshProducts();
    });
}

$('#outside-button').on('click', function(event) {
    event.preventDefault();
    $('#form').submit();
});

$( window ).on( "load", function() {
    $('.thumbs .row .col-xs-12').each(function() { 
         if ($(this).find('a').attr('href').indexOf('.mp4') !== -1) {
             $(this).find('a').mouseenter();
         }
    });
});
